<template>
  <v-layout row>
    <v-flex md9>
      <div class="tableSubTitle">残有給休暇</div>
      <table>
        <tr>
          <th>有給有効期限</th>
          <th>残日数</th>
        </tr>
        <tr v-for="(item, i) in items" :key="i">
          <th>{{item.label}}</th>
          <td>{{item.days}}</td>
        </tr>
        <th>今月末の残日数</th>
        <td>{{paidDaysOffCount}}</td>
        <tr></tr>
      </table>
    </v-flex>
  </v-layout>
</template>
<script>
import { unixtimeToJapaneseShortFormattedDate } from "@/utils/datetime.js";
import { mapGetters } from "vuex";
export default {
  data: () => ({
    items: []
  }),
  computed: {
    ...mapGetters("timesheet", ["paidDayOffItems", "paidDaysOffCount"])
  },
  mounted() {
    this.reloadItem();
  },
  watch: {
    paidDaysOff() {
      this.reloadItem();
    }
  },
  methods: {
    reloadItem() {
      this.items = [];
      this.paidDayOffItems.forEach(item => {
        if (item.isDisplayed) {
          this.items.push({
            label: unixtimeToJapaneseShortFormattedDate(item.deadline),
            days: item.days_left
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
table {
  margin: 10px;
  border: solid 1px;
  border-collapse: collapse;
}
th {
  text-align: left;
}
th,
td {
  border: solid 1px;
  padding: 5px 10px;
}
td {
  text-align: right;
}
.tableSubTitle {
  font-size: 14px;
  color: #616161;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
</style>